module.exports = __webpack_public_path__ + "../static/media/cnrs.b8d2c80b.jpg";